import React, { useState, useEffect, useContext, useCallback } from 'react';
import { Modal, Input, Button, List } from 'antd';
import axios from 'axios';
import MyContext from './MyContext';

function FileManager() {
  const [fileName, setFileName] = useState("");
  const [savedFiles, setSavedFiles] = useState([]);
  const {
    selectedKey,
    isModalVisible,
    setIsModalVisible,
    setSelectedFile
  } = useContext(MyContext);

  // Define module information with API endpoints and types
  const moduleConfig = React.useMemo(() => ({
    "1": {
      endpoint: "/api/list_crossover/",
      type: "crossover",
      title: "Crossover Analysis File Manager"
    },
    "2": {
      endpoint: "/api/list-files/",
      type: "direct", // Goes directly to main table
      title: "Breakeven File Manager"
    },
    "5": {
      endpoint: "/api/list_leastSquares/",
      type: "least_squares",
      title: "Least Squares Analysis File Manager"
    },
    "3": {  // Add this configuration
      endpoint: "/api/list_multiproduct/",
      type: "multiproduct",
      title: "Multiproduct BreakEven File Manager"
    },
    "10": {  // Add this configuration for Kanban Computation
      endpoint: "/api/list_kanban_computations/",
      type: "kanban",
      title: "Kanban Computation File Manager"
    },
    "11": {
      endpoint: "/api/list_preferencematrix/",
      type: "config", // Requires additional configuration
      title: "Preference Matrix File Manager"
    },
    "8": {
      endpoint: "/api/list_eoq/",
      type: "EOQ", // Requires additional configuration
      title: "EOQ Model File Manager"
    },
    "9": {  // Add this configuration for ABC Analysis
      endpoint: "/api/list_abc_analyses/",
      type: "abc",
      title: "ABC Analysis File Manager"
    },
    "12": {  // Add this configuration for Error Analysis
      endpoint: "/api/list_error_analysis/",
      type: "erroranalysis",
      title: "Error Analysis File Manager"
    },
    "6": {  // Add this configuration for Regression Projector
      endpoint: "/api/list_regressions_projector/",
      type: "regressionprojector",
      title: "Regression Projector File Manager"
    },
    "13": {  // Add this configuration for Economic Production Lot Size
      endpoint: "/api/list_economic_production_lotsize/",
      type: "productionlotsize",
      title: "Economic Production Lot Size File Manager"
    },
    "14": {  // Add this configuration for Time Study
      endpoint: "/api/list_time_studies/",
      type: "timestudy",
      title: "Time Study File Manager"
    },
    "15": {  // Add this configuration for Sample Size Time Study
      endpoint: "/api/list_sample_size_for_ts/",
      type: "samplesize_timestudy",
      title: "Sample Size for Time Studies File Manager"
    },
    "20": {  // Add this configuration for Reorder Point/Safety Stock (Normal Dist)
      endpoint: "/api/list_reorder_normal_dist/",
      type: "reorderpoint_normaldist",
      title: "Reorder Point/Safety Stock (Normal Distribution) File Manager"
    },
    "21": {  // Add this configuration for Decision Table
      endpoint: "/api/list_decision_tables/",
      type: "decision_table",
      title: "Decision Table File Manager"
    },
    "23": {  // Add this configuration for Quantity Discount (EOQ) Model
      endpoint: "/api/list_quantityDiscountEoq/",
      type: "quantity_discount_EOQ",
      title: "Quantity Discount (EOQ) File Manager"
    },
    "17": {  // Add this configuration for Single Period Inventory Discrete
      endpoint: "/api/list_single_period_discrete/",
      type: "single_period_discrete",
      title: "Single Period Inventory (Discrete) File Manager"
    },
    "24": {
      endpoint: "/api/list_PM_mean_stddev/",
      type: "pm_mean_stddev",
      title: "Project Management (Mean & Std Dev) File Manager"
    },
    "18": {  // Add this configuration for Single Period Inventory Normal
      endpoint: "/api/list_single_period_normal/",
      type: "single_period_normal",
      title: "Single Period Inventory (Normal) File Manager"
    },
    "19": {  // Add this configuration for Reorder Point Safety Stock Discrete
      endpoint: "/api/list_reorder_point_safety_stock/",
      type: "reorderpoint_discrete",
      title: "Reorder Point / Safety Stock (Discrete) File Manager"
    },
    "25": {
      endpoint: "/api/list_AggregatePlanning/",
      type: "aggregate_planning",
      title: "Aggregate Planning File Manager"
    },
    "4": {
      endpoint: "/api/list_timeSeriesAnalysis/",
      type: "time_series_analysis",
      title: "Time Series Analysis File Manager"
    },
    "26": {
      endpoint: "/api/list_transport/",
      type: "transport",
      title: "Transport Analysis File Manager"
    },
    "27": {
      endpoint: "/api/list_normal_distribution/",
      type: "normal_distribution",
      title: "Normal Distribution File Manager"
    },
    "28": {
      endpoint: "/api/list_P_ChartModule_QualityAndPerformance/",
      type: "P_ChartModule_QualityAndPerformance",
      title: "P-Chart (Quality Control) File Manager"
    },
    "29": {
      endpoint: "/api/list_determine_time_given_by_a_learning_coefficient/",
      type: "learning_curve_determine_time",
      title: "Learning Curve (Determine Time) File Manager"
    },
    "30": {
      endpoint: "/api/list_Markov_Analysis/",
      type: "markov_analysis",
      title: "Markov Analysis File Manager"
    },
    "58": {
      endpoint: "/api/list_Erlang_k/",
      type: "erlang_k",
      title: "Erlang-k Service Times File Manager"
    },
    "53": {
      endpoint: "/api/list_center_of_gravity/",
      type: "center_of_gravity",
      title: "Center of Gravity File Manager"
    },
    "55": {
      endpoint: "/api/list_single_server_model/",
      type: "single_server_model",
      title: "Single-Server Model File Manager"
    },
    "59": {
      endpoint: "/api/list_Multiple_Server_Model/",
      type: "multiple_server_model",
      title: "Multiple-Server Model File Manager"
    },
    "48": {
      endpoint: "/api/list_data_analysis/",
      type: "data_analysis",
      title: "Data Analysis File Manager"
    },
    "39": {
      endpoint: "/api/list_linear_programming/",
      type: "linear_programming",
      title: "Linear Programming File Manager"
    },
    "31": {
      endpoint: "/api/list_xBarCharts/",
      type: "x_bar_charts",
      title: "x-bar Charts File Manager"
    },
    "64": {
      endpoint: "/api/list_xBarCharts/",
      type: "x_bar_charts",
      title: "x-bar Charts File Manager"
    },
    "63": {
      endpoint: "/api/list_P_ChartModule_QualityAndPerformance/",
      type: "P_ChartModule_QualityAndPerformance",
      title: "P-Chart (Quality Control) File Manager"
    },
    "62": {
      endpoint: "/api/list_preferencematrix/",
      type: "config",
      title: "Preference Matrix File Manager"
    },
    "67": {
      endpoint: "/api/list_AggregatePlanning/",
      type: "aggregate_planning",
      title: "Aggregate Planning File Manager"
    },
    "68": {
      endpoint: "/api/list_transport/",
      type: "transport",
      title: "Transport Analysis File Manager"
    },
    "60": {
      endpoint: "/api/list_finiteSource/",
      type: "finite_source",
      title: "Finite-Source Model File Manager"
    },
    "61": {
      endpoint: "/api/list_finiteSystemSizeModel/",
      type: "finite_system_size",
      title: "Finite System Size Model File Manager"
    },
    "49": {
      endpoint: "/api/list_Binomial_dist/",
      type: "binomial_distribution",
      title: "Binomial Distribution File Manager"
    },
    "34": {
      endpoint: "/api/list_transportation_model/",
      type: "transportation_model",
      title: "Transportation Model (Planning) Manager"
    },
    "68": {
      endpoint: "/api/list_transportation_model/",
      type: "transportation_model",
      title: "Transportation Model (Production) Manager"
    },
    "50": {
      endpoint: "/api/list_poisson_distribution/",
      type: "poisson_distribution",
      title: "Poisson Distribution File Manager"
    },

    "33": {
      endpoint: "/api/list_cpk/",
      type: "cpk",
      title: "Process Capability (Cpk) File Manager"
    },
    "66": {
      endpoint: "/api/list_cpk/",
      type: "cpk",
      title: "Process Capability (Cpk) File Manager"
    },
    "51": {
      endpoint: "/api/list_ExponentialDistribution/",
      type: "exponential",
      title: "Exponential Distribution File Manager"
    },
    "56": {
      title: "Constant Service Times File Manager",
      endpoint: "/api/list_constant_service_times/",
      type: "constant_service_times"
    },
    "57": {
      title: "General Service Times File Manager",
      endpoint: "/api/list_general_service_times/",
      type: "general_service_times"
    },
    "52": {
      title: "General Weighting Method File Manager",
      endpoint: "/api/list_general_weighting_method/",
      type: "general_weighting"
    },
    "47": {
      endpoint: "/api/list_simulation/",
      type: "simulation",
      title: "Simulation Model File Manager"
    },
    "43": {
      endpoint: "/api/list_cost_budgeting/",
      type: "cost_budgeting",
      title: "Cost Budgeting File Manager"
    }
  }), []);

  const fetchSavedFiles = useCallback(async () => {
    try {
      const token = localStorage.getItem("access_token");
      const endpoint = moduleConfig[selectedKey]?.endpoint;
      if (!endpoint) {
        setSavedFiles([]);
        return;
      }
      const response = await axios.get(endpoint, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSavedFiles(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching saved files:", error);
      setSavedFiles([]);
    }
  }, [moduleConfig, selectedKey, setSavedFiles]);

  useEffect(() => {
    if (isModalVisible && moduleConfig[selectedKey]) {
      fetchSavedFiles();
      setFileName("");
    }
  }, [isModalVisible, selectedKey, moduleConfig, fetchSavedFiles]);

  const handleCreateNewFile = () => {
    console.log("Button clicked");
    console.log("File Name:", fileName);
    console.log("Selected Key:", selectedKey);

    if (!fileName) return;

    const fileType = moduleConfig[selectedKey]?.type || "config";

    console.log("File Type:", fileType);
    console.log("selectedKey:", selectedKey);
    console.log("module config:", moduleConfig[selectedKey]);
    console.log("type:", moduleConfig[selectedKey]?.type);
    setSelectedFile({
      id: null,
      name: fileName,
      module: selectedKey,
      type: fileType
    });

    console.log("setSelectedFile called");

    setIsModalVisible(false);
  };

  const handleOpenFile = (file) => {
    setSelectedFile({
      ...file,
      module: selectedKey,
      type: moduleConfig[selectedKey].type
    });

    setIsModalVisible(false);
  };

  return (
    <Modal
      title={moduleConfig[selectedKey]?.title || "File Manager"}
      open={isModalVisible}
      onCancel={() => setIsModalVisible(false)}
      footer={null}
      width={selectedKey === "51" ? 520 : undefined}
    >
      <Input
        placeholder="Enter new file name"
        value={fileName}
        onChange={(e) => setFileName(e.target.value)}
        style={{ marginBottom: '10px' }}
      />
      <Button type="primary" onClick={handleCreateNewFile} disabled={!fileName}>
        Create New File
      </Button>
      <h4>Open Existing File</h4>
      <List
        bordered
        dataSource={Array.isArray(savedFiles) ? savedFiles : []}
        locale={{ emptyText: "No Data" }}
        renderItem={(file) => (
          <List.Item
            onClick={() => handleOpenFile(file)}
            style={{ cursor: 'pointer' }}
          >
            {file.name}
          </List.Item>
        )}
      />
    </Modal>
  );
}

export default FileManager;